<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fName"
        placeholder="经销商名称"
        size="small"
        style="width: 200px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
        >新增</el-button
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fName" label="经销商名称" min-width="250" />
        <el-table-column prop="fCorperate" label="负责人" width="90" />
        <el-table-column prop="fPhone" label="电话" />
        <el-table-column prop="fEmail" label="Email" />
        <el-table-column prop="fDes" label="简介" />
        <el-table-column label="操作" class-name="table-oper-col" width="90">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >查看</el-button
              >
            </template>
            <template>
              <ConfirmButton v-if="canDel" @confirm="_delete(scope.row)"
                >删除</ConfirmButton
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EditForm from "./EditForm";
import ConfirmButton from "@components/ConfirmButton";

export default {
  components: {
    EditForm,
    ConfirmButton,
  },
  data() {
    return {
      query: {
        fName: null,

        pageIndex: 1,
        pageSize: 20,
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true,
    };
  },
  mounted() {
    this.refresh();

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == "004007002") {
        this.canAdd = val.isGrant;
      }
      if (val.key == "004007003") {
        this.canEdit = val.isGrant;
      }
      if (val.key == "004007004") {
        this.canDel = val.isGrant;
      }
    });
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$httpPost(
        "BasicInformation/Distributor/DistributorEntry",
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist.dataEntry;
          this.pageRecordTotal = res.datalist.total;
        })
        .finally(() => (this.loading = false));
    },
    _modify: async function (row) {
      const isNew = !row;
      if (isNew) {
        this.currentEditItem = {
          fRegionID: null,
          userNumber: await this.getUserName(),
          fPassword: null,
          fName: null,
          fCorperate: null,
          fLevel: 1,
          fDeductionRatio: 100,
          fPhone: null,
          fMobilePhone: null,
          fEmail: null,
          fAddress: null,
          fDes: null,
          fKdISName: false,
        };
      } else {
        this.currentEditItem = await this.$httpPost(
          "BasicInformation/Distributor/GetDistributor",
          { fid: row.fDistributorID }
        ).then((res) => res.datalist);
      }
      let or;
      if (isNew) {
        or = this.canAdd;
      } else {
        or = this.canEdit;
      }
      const h = this.$createElement;
      this.$formDlg({
        title: isNew ? "新建经销商" : `查看经销商`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: "80%",
        readonly: !or,
      });
    },
    _delete(row) {
      this.postData(2, row);
    },
    postData(modifyType, info) {
      return this.$httpPost(`BasicInformation/Distributor/DistributorModify`, {
        datalist: JSON.stringify({
          modifyType,
          info,
        }),
      }).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          if (res.returnCode == "00009") {
            this.currentEditItem.userNumber = await this.getUserName(); // 刷新用户名
          }
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    getUserName: function () {
      return this.$httpPost(
        "BasicInformation/Distributor/MaxDistributorNu"
      ).then((res) => res.datalist);
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
